var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { SvgIcon } from '../svg-icon';
export var FontIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentColor' : _b, rootProps = __rest(_a, ["color"]);
    return (React.createElement(SvgIcon, __assign({ viewBox: "0 0 24 24" }, rootProps),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 10H11V7H9.5V17.5H14C14.2104 17.4995 14.4165 17.4551 14.6055 17.3716C14.7734 17.2974 14.9277 17.1924 15.0601 17.0601C15.3413 16.7788 15.4995 16.3975 15.5 16V11.5C15.4995 11.2808 15.4512 11.0664 15.3608 10.8706C15.2871 10.7119 15.186 10.5659 15.0601 10.4399C14.7788 10.1587 14.3975 10.0005 14 10ZM11 16V11.5H14V16H11ZM22.25 17.5H18.5C18.1025 17.4995 17.7212 17.3413 17.4399 17.0601C17.1587 16.7788 17.0005 16.3975 17 16V11.5C17.0005 11.1025 17.1587 10.7212 17.4399 10.4399C17.7212 10.1587 18.1025 10.0005 18.5 10H22.25V11.5H18.5V16H22.25V17.5ZM2.75 10H6.5C6.89746 10.0005 7.27881 10.1587 7.56006 10.4399C7.84131 10.7212 7.99951 11.1025 8 11.5V17.5H3.5C3.10205 17.5 2.7207 17.3418 2.43945 17.0605C2.1582 16.7793 2 16.3979 2 16V14.5C2 14.1021 2.1582 13.7207 2.43945 13.4395C2.7207 13.1582 3.10205 13 3.5 13H6.5V11.5H2.75V10ZM3.5 16H6.5V14.5H3.5V16Z", fill: color })));
};
